/*
 * @providesModule FTUEStyles
 *
 *
 * Created by Skillz on 3/1/16.
 *   Copyright © 2016 Skillz. All rights reserved.
 *
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';
import {StyleSheet} from 'react-native';
import ClientPropertyConstants from 'ClientPropertyConstants';
const {
  fontSecondary,
  fontSizeH1,
  fontSizeH3,
  fontSizeH2,
  fontSizeH4,
  fontPrimary,
  viewCornerRadiusPrimary,
  viewBoxShadowPrimary,
  btnTextColorTwo,
} = SkillzStyle.fullStyles;

export const ftueBackgroundOpacity = 75; // value defined by product
export const ftueAnimationInterval = 3000; // value defined by product
export const ftueAnimationDuration = ClientPropertyConstants.getFTUERevampEnabled() ? 1 : 3000; // value defined by product
export default StyleSheet.create({
  titleText: {
    marginTop: 16,
    marginBottom: 10,
    textAlign: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeH3.fontSize,
      lg: fontSizeH1.fontSize,
      xxlg: fontSizeH2.fontSize,
    }),
    color: '#4A4A4A',
    ...fontSecondary,
  },

  detailText: {
    marginBottom: 6,
    marginHorizontal: 10,
    textAlign: 'center',
    color: '#4A4A4A',
    ...fontPrimary,
    ...Sizes.select({
      landscapeTablet: {...fontSizeH3},
      other: {...fontSizeH4},
    }),
  },

  fullScreenContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  dropShadowContainer: Object.assign({
    paddingHorizontal: 14,
    flexGrow: 1,
    paddingVertical: 30,
    backgroundColor: SkillzStyle.convertToOpacity('#000000', ftueBackgroundOpacity / 100),
  }),

  // Needed so we can position close but absolutely within the modal
  contentBox: {
    position: 'relative',
    paddingBottom: 14,
    paddingTop: 8,
    paddingHorizontal: 0,
    flexDirection: 'column',
    backgroundColor: 'white',
    borderColor: '#000000',
    borderWidth: 1,
    shadowColor: '#000000',
    shadowOffset: {width: 0, height: 1},
    shadowRadius: 2,
    shadowOpacity: 0.7,
    elevation: 7,
    alignItems: 'center',
    justifyContent: 'center',
    ...viewCornerRadiusPrimary,
  },

  buttonContainer: {
    flexDirection: 'row',
    height: 42,
    marginHorizontal: 5,
    marginTop: 10,
    backgroundColor: 'transparent',
  },

  button: {
    height: 42,
    flexGrow: 1,
    paddingHorizontal: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 10,
    backgroundColor: 'transparent',
    ...viewCornerRadiusPrimary,
    ...viewBoxShadowPrimary,
  },

  buttonText: {
    flexGrow: 1,
    marginHorizontal: 5,
    textAlign: 'center',
    backgroundColor: 'transparent',
    ...fontSecondary,
    ...fontSizeH2,
    ...btnTextColorTwo,
  },

  FTUECloseButton: {
    marginVertical: 0,
    marginHorizontal: 0,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 5,
    top: 5,
    marginTop: 0,
  },

  FTUECloseButtonImage: {
    width: 25,
    height: 25,
  },

  FTUETextContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    paddingHorizontal: 16,
    backgroundColor: 'transparent',
  },
});
